<template lang="pug">
  .modal.is-active
    .modal-background(@click="cerrarModal")
    .modal-content
      .box
        h5.title {{ config.title }}
        br
        .columns
          .column.is-12
            .field
              label.label {{ config.content }}
              .control
                input.input.is-primary(
                  type='text', 
                  placeholder="",
                  v-model="valor",
                )
        .columns(v-show="Object.keys(datosFaltantes).length > 0")
          .column.is-12
            .notification
              button.delete(@click="closeNotification")
              .field.is-grouped.is-grouped-multiline
                .control(v-for="datosF in datosFaltantes")
                  .tags
                    span.tag.is-danger.is-light {{ datosF }}
        .columns
          .column
            .level-right
              .field.is-grouped
                p.control
                  a.button.is-rounded(:class="config.classCancel" @click="cerrarModal")
                    | {{ config.textCancel }}
                p.control
                  a.button.is-black.is-rounded(:class="config.classOk" @click="checkForm")
                    | {{ config.textOk }}
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'ModalDatos',
    props: {
      config: {
        type: Object,
        default: ()=> {}
      },
      articuloSel: {
        type: Object,
        default: () => {},
      }
    },
    data() {
      return {
        valor: '',
        datosFaltantes: [],
      }
    },
    watch: {
      articuloSel() {
        console.log('watch' + this.articuloSel.idSAP)
        this.valor = this.articuloSel.idSAP
      }
    },
    methods: {
      cerrarModal () {
        this.$emit('changeIdSAP', 'close')
        this.puestoSel = {}
      },
      
      saveData () {
        if (this.permisos.inventarios == 6) {
          return
        }
        this.$emit('changeIdSAP', this.valor)
      },
      
      checkForm() {
        this.datosFaltantes = []
        if (this.valor) {
          this.saveData()
        } else {
          if (!this.puestoSel) {
            this.datosFaltantes.push('Debe introducir un dato')
          }
        }
      },
      
      closeNotification() {
        this.datosFaltantes = []
      }
    },
    computed: {
      ...mapState(['userLogin', 'permisos'])
    },
  }
</script>




// WEBPACK FOOTER //
// src/components/inventario_Componentes/shared/ModalInput.vue